export default "__VITE_ASSET__3de86aed__"